import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 },
  };

  const timeline = [
    { year: '2000', event: 'Hukuk bürosu İstanbul\'da kuruldu' },
    { year: '2005', event: 'Uluslararası hukuk departmanı açıldı' },
    { year: '2010', event: 'Kurumsal hukuk alanında lider konuma ulaşıldı' },
    { year: '2015', event: 'Chambers & Partners tarafından Band 1 kategorisinde tanındı' },
    { year: '2020', event: '500+ başarılı dava sayısına ulaşıldı' },
    { year: '2025', event: 'Türkiye\'nin en prestijli hukuk bürolarından biri olarak tanınıyor' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-navy-900">
        <div className="absolute inset-0 opacity-10">
          <div
            className="w-full h-full"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23C9A961' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            }}
          ></div>
        </div>
        <div className="relative max-w-[1200px] mx-auto px-6 lg:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-block px-6 py-2 border border-gold-500 rounded-full mb-6">
              <span className="text-xs font-sans uppercase tracking-widest text-gold-500">HAKKIMIZDA</span>
            </div>
            <h1 className="font-serif text-5xl lg:text-6xl text-white mb-6">
              Mükemmellik ve Dürüstlük<br />Üzerine Kurulu
            </h1>
            <p className="font-sans text-lg text-white/80 max-w-3xl mx-auto leading-relaxed">
              25 yılı aşkın deneyimimizle, İstanbul'un en saygın hukuk bürolarından biri olarak ulusal ve uluslararası müvekkillerimize en yüksek kalitede hukuki hizmet sunuyoruz.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div {...fadeInUp}>
              <img
                src="https://public.readdy.ai/ai/img_res/b91f006ccf7f2b3f713c793cbb3132e0.jpg"
                alt="Our Vision"
                className="w-full h-[500px] object-cover rounded-lg shadow-xl"
              />
            </motion.div>

            <motion.div {...fadeInUp}>
              <div className="w-16 h-16 flex items-center justify-center bg-gold-500/10 rounded-lg mb-6">
                <i className="ri-eye-line text-3xl text-gold-500"></i>
              </div>
              <h2 className="font-serif text-4xl text-navy-900 mb-6">Vizyonumuz</h2>
              <p className="font-sans text-base text-gray-700 leading-relaxed mb-4">
                Türkiye'nin en saygın ve güvenilir hukuk bürolarından biri olarak, müvekkillerimize dünya standartlarında hukuki hizmet sunmayı hedefliyoruz. Etik değerlere olan bağlılığımız, mükemmellik arayışımız ve müvekkil odaklı yaklaşımımız ile sektörde öncü olmayı sürdürüyoruz.
              </p>
              <p className="font-sans text-base text-gray-700 leading-relaxed mb-4">
                Ulusal ve uluslararası hukuk alanında sürekli gelişen bir büro olarak, müvekkillerimizin karmaşık hukuki ihtiyaçlarına yenilikçi ve stratejik çözümler üretiyoruz. Deneyimli avukat kadromuz, geniş uzmanlık alanlarımız ve güçlü uluslararası ağımız ile müvekkillerimize kapsamlı hukuki destek sağlıyoruz.
              </p>
              <p className="font-sans text-base text-gray-700 leading-relaxed">
                Vizyonumuz, sadece hukuki sorunları çözmek değil, aynı zamanda müvekkillerimizin iş hedeflerine ulaşmalarında stratejik ortak olmaktır. Her müvekkilimizin başarısını kendi başarımız olarak görüyor ve bu doğrultuda en yüksek kalitede hizmet sunmaya devam ediyoruz.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Legal Philosophy */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div {...fadeInUp} className="order-2 lg:order-1">
              <div className="w-16 h-16 flex items-center justify-center bg-gold-500/10 rounded-lg mb-6">
                <i className="ri-lightbulb-line text-3xl text-gold-500"></i>
              </div>
              <h2 className="font-serif text-4xl text-navy-900 mb-6">Hukuki Felsefemiz</h2>
              <p className="font-sans text-base text-gray-700 leading-relaxed mb-4">
                Her müvekkilimizin benzersiz ihtiyaçları ve hedefleri olduğuna inanıyoruz. Bu nedenle, standart çözümler yerine, her vaka için özelleştirilmiş stratejiler geliştiriyoruz. Detaylı analiz, yaratıcı düşünce ve stratejik planlama ile müvekkillerimizin en iyi sonuçları elde etmelerini sağlıyoruz.
              </p>
              <p className="font-sans text-base text-gray-700 leading-relaxed mb-4">
                Proaktif yaklaşımımız sayesinde, potansiyel hukuki riskleri önceden tespit ediyor ve önleyici tedbirler alıyoruz. Reaktif değil, proaktif hukuki danışmanlık anlayışımız ile müvekkillerimizin zaman, maliyet ve enerji tasarrufu yapmalarını sağlıyoruz.
              </p>
              <p className="font-sans text-base text-gray-700 leading-relaxed">
                Hukuki mükemmelliğin yanı sıra, iş dünyasını da derinlemesine anlıyoruz. Bu sayede, sadece hukuki açıdan doğru değil, aynı zamanda ticari açıdan da mantıklı çözümler sunuyoruz. Müvekkillerimizin iş hedeflerini anlıyor ve bu hedeflere ulaşmalarında hukuki destek sağlıyoruz.
              </p>
            </motion.div>

            <motion.div {...fadeInUp} className="order-1 lg:order-2">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20attorneys%20discussing%20legal%20strategy%20in%20modern%20conference%20room%20with%20documents%20and%20laptops%20collaborative%20legal%20work%20contemporary%20office%20setting%20premium%20business%20photography&width=700&height=600&seq=about2&orientation=landscape"
                alt="Legal Philosophy"
                className="w-full h-[500px] object-cover rounded-lg shadow-xl"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Client Approach */}
      <section className="py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div {...fadeInUp}>
              <img
                src="https://readdy.ai/api/search-image?query=professional%20attorney%20client%20consultation%20in%20elegant%20law%20office%20with%20warm%20lighting%20trust%20and%20confidence%20atmosphere%20modern%20legal%20meeting%20premium%20office%20photography&width=700&height=600&seq=about3&orientation=landscape"
                alt="Client Approach"
                className="w-full h-[500px] object-cover rounded-lg shadow-xl"
              />
            </motion.div>

            <motion.div {...fadeInUp}>
              <div className="w-16 h-16 flex items-center justify-center bg-gold-500/10 rounded-lg mb-6">
                <i className="ri-team-line text-3xl text-gold-500"></i>
              </div>
              <h2 className="font-serif text-4xl text-navy-900 mb-6">Müvekkil Yaklaşımımız</h2>
              <p className="font-sans text-base text-gray-700 leading-relaxed mb-4">
                Müvekkillerimizle uzun vadeli, güvene dayalı ilişkiler kurmayı önceliklendiriyoruz. Her müvekkilimizi dinliyor, ihtiyaçlarını anlıyor ve beklentilerini karşılayacak çözümler üretiyoruz. Şeffaf iletişim, dürüstlük ve güvenilirlik, müvekkil ilişkilerimizin temel taşlarıdır.
              </p>
              <p className="font-sans text-base text-gray-700 leading-relaxed mb-4">
                Müvekkillerimize sadece hukuki danışmanlık değil, aynı zamanda stratejik ortaklık sunuyoruz. İş hedeflerinizi anlıyor, sektörünüzü inceliyor ve size en uygun hukuki çözümleri sunuyoruz. Başarınız bizim başarımızdır ve bu doğrultuda en yüksek kalitede hizmet sunmaya devam ediyoruz.
              </p>
              <div className="space-y-4 mt-8">
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-gold-500 rounded-md flex-shrink-0">
                    <i className="ri-shield-check-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-sans text-lg font-semibold text-navy-900 mb-1">Gizlilik ve Güvenlik</h4>
                    <p className="font-sans text-sm text-gray-600">Müvekkil bilgilerinin gizliliği en üst düzeyde korunur</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-gold-500 rounded-md flex-shrink-0">
                    <i className="ri-time-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-sans text-lg font-semibold text-navy-900 mb-1">Hızlı Yanıt</h4>
                    <p className="font-sans text-sm text-gray-600">Müvekkil taleplerine en kısa sürede yanıt veriyoruz</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-gold-500 rounded-md flex-shrink-0">
                    <i className="ri-star-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-sans text-lg font-semibold text-navy-900 mb-1">Mükemmellik</h4>
                    <p className="font-sans text-sm text-gray-600">Her vakada en yüksek kalite standartlarını uyguluyoruz</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-24 bg-navy-900">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <motion.div {...fadeInUp} className="text-center mb-16">
            <h2 className="font-serif text-4xl lg:text-5xl text-white mb-4">Gelişim Sürecimiz</h2>
            <p className="font-sans text-lg text-white/80 max-w-2xl mx-auto">
              25 yıllık yolculuğumuzda önemli kilometre taşları
            </p>
          </motion.div>

          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 w-0.5 h-full bg-gold-500/30"></div>
            
            <div className="space-y-12">
              {timeline.map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: index % 2 === 0 ? -60 : 60 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className={`flex items-center ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}
                >
                  <div className={`w-1/2 ${index % 2 === 0 ? 'pr-12 text-right' : 'pl-12 text-left'}`}>
                    <div className="inline-block px-4 py-2 bg-gold-500 rounded-full mb-3">
                      <span className="font-sans text-sm font-bold text-white">{item.year}</span>
                    </div>
                    <p className="font-sans text-base text-white/90">{item.event}</p>
                  </div>
                  <div className="w-4 h-4 bg-gold-500 rounded-full border-4 border-navy-900 z-10"></div>
                  <div className="w-1/2"></div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <motion.div {...fadeInUp} className="text-center mb-16">
            <h2 className="font-serif text-4xl lg:text-5xl text-navy-900 mb-4">Değerlerimiz</h2>
            <p className="font-sans text-lg text-gray-600 max-w-2xl mx-auto">
              Çalışmalarımızı yönlendiren temel ilkeler
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: 'ri-shield-star-line', title: 'Dürüstlük', desc: 'Her işimizde en yüksek etik standartları uyguluyoruz' },
              { icon: 'ri-trophy-line', title: 'Mükemmellik', desc: 'Sürekli gelişim ve en iyi sonuçlar için çabalıyoruz' },
              { icon: 'ri-hand-heart-line', title: 'Bağlılık', desc: 'Müvekkillerimizin başarısına tam bağlılık gösteriyoruz' },
              { icon: 'ri-lightbulb-flash-line', title: 'Yenilikçilik', desc: 'Yaratıcı ve stratejik çözümler üretiyoruz' },
            ].map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center p-8 bg-gray-50 rounded-lg hover:shadow-lg transition-shadow"
              >
                <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-gold-500 rounded-lg">
                  <i className={`${value.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="font-sans text-xl font-semibold text-navy-900 mb-3">{value.title}</h3>
                <p className="font-sans text-sm text-gray-600 leading-relaxed">{value.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;